export const DEFAULT_FONT_SIZE = 16;

export const TAB_IDS: { [key: string]: string; } = {
  AGENDA: 'AGENDA',
  TIMELINE: 'TIMELINE',
  SHOT_LIST: 'SHOT_LIST',
  TASK_LIST: 'TASK_LIST',
  CHAT: 'CHAT',
  HOME: 'HOME',
  SETTINGS: 'SETTINGS'
};



// WEBPACK FOOTER //
// ./src/constants.js